import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = { class: "flex items-center justify-between mb-2" }
const _hoisted_2 = { class: "text-base text-black-lp-200 font-bold -mt-2 text-left" }
const _hoisted_3 = { class: "text-left text-sm text-black-lp-200 bg-gray-lp-200 p-4" }
const _hoisted_4 = { id: "copy-text" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Snackbar = _resolveComponent("Snackbar")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue = $event)),
      customBody: "px-8 py-3",
      showOverflow: true,
      customWidth: "max-w-full p-6"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('dashboard.copyTemplate.templateText')), 1),
          _createVNode("img", {
            src: _imports_0,
            class: " w-6 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCloseModal())),
            alt: "x"
          })
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                (_ctx.awb?.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.$t('dashboard.copyTemplate.greeting', { accountType: _ctx.accountTypeMsg, cityCode: _ctx.accountData.account_type_detail.partnerLocation?.city?.code })) + " ", 1),
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.copyTemplate.followUpHanging', { groupName: _ctx.groupName })) + " ", 1),
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.copyTemplate.totalAwb', { totalAwb: _ctx.awb.length, totalPiece: _ctx.getTotalPiece })) + " ", 1),
                      _hoisted_8,
                      _createVNode("ol", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.awb, (item, index) => {
                          return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(_ctx.$t('dashboard.copyTemplate.awbItem', { awbNo: item.awbNo, origin: item.origin3lc })), 1))
                        }), 128))
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard.copyTemplate.helpThanks')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_lp_button, {
                textColor: "black-lp-200",
                color: "white",
                iconLeft: "ics_f_copy",
                title: _ctx.$t('dashboard.copyTemplate.copyText'),
                onClick: _ctx.copyText
              }, null, 8, ["title", "onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_Snackbar, {
      modelValue: _ctx.showToast,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showToast = $event)),
      iconLeft: "ics_f_check_circle",
      message: _ctx.$t('dashboard.copyTemplate.copiedSuccess'),
      "is-positive": true,
      timeout: 3,
      autoClose: true,
      snackbarBackgroundColor: "white",
      textColor: "text-green-lp-100 font-bold"
    }, null, 8, ["modelValue", "message"])
  ]))
}